import { ITax } from "@app/common";

export interface TaxFormValues extends Partial<ITax> { }

